import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const ChannelStore = require('../../stores/channel_store_reflux');
const ProjectStore = require('../../stores/ProjectStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
import Navigator from '../../Navigator';
import MainNav from '../DashboardNew/Menu/MainNav';
import SubNav from '../nav/SubNav';
import BackButton from '../nav/BackButton';
import BreadCrumbs from '../common/BreadCrumbs';
import ProjectAnalytics from './ProjectAnalytics';

const propTypes = {
    match: PropTypes.shape({
        params: PropTypes.object.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
};

const defaultProps = {};

class ProjectAnalyticsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getState(),
            projectStoreState: ProjectStore.getStateProject(parseInt(props.match.params.projectId, 10)),
        };

        this.backHandler = this.backHandler.bind(this);
        this.checkAnalyticsPermissions = this.checkAnalyticsPermissions.bind(this);
        this.unsubscribes = [ChannelStore.listen(this.onChannelStoreChange.bind(this)),
            ProjectStore.listen(this.onProjectStoreChange.bind(this))];
    }

    componentDidMount() {
        this.checkAnalyticsPermissions(this.state.channelStoreState, this.state.projectStoreState);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onChannelStoreChange(state) {
        if (state.initialized) {
            const currentChannel = state.channelsAndOrgs.find(ch => ch.id === parseInt(this.props.match.params.channelId, 10));
            if (!currentChannel) { // channel does not exist or user does not have permissions in channel
                Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING)
                return;
            }
        }

        this.setState({ channelStoreState: state }, () => {
            this.checkAnalyticsPermissions(state, this.state.projectStoreState);
        });
    }

    onProjectStoreChange(state) {
        let newState = ProjectStore.getStateProject(parseInt(this.props.match.params.projectId, 10));
        if (newState.initialized && !newState.project) { // project does not exist or user does not have permissions in channel
            Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING)
            return;
        }

        this.setState({ projectStoreState: newState }, () => {
            this.checkAnalyticsPermissions(this.state.channelStoreState, newState);
        });
    }

    checkAnalyticsPermissions(channelStoreState, projectStoreState) {
        if (channelStoreState.initialized && projectStoreState.initialized) {
            const currentChannel = channelStoreState.channelsAndOrgs.find(ch => ch.id === parseInt(this.props.match.params.channelId, 10));
            const currentProject = projectStoreState.project;

            // account does not have detailed analytics
            if (!FeatureUtil.hasDetailedAnalytics(currentChannel.channel_permissions)) {
                console.warn('Account does not have Detailed Analytics feature');
                this.backHandler();
                return;
            }

            // user does not have project/channel permissions to view analytics
            if (!PermissionsUtil.viewDetailedProjectAnalytics(currentChannel.user_permissions, currentProject.user_permissions)) {
                this.backHandler();
                return;
            }
        }
    }

    backHandler() {
        Navigator.goToProjectView(this.props.history, this.props.match.params.channelId, this.props.match.params.projectId)
    }

    render() {
        if (!this.state.channelStoreState.initialized || !this.state.projectStoreState.initialized) {
            return null;
        }

        const currentChannelId = parseInt(this.props.match.params.channelId, 10);
        const currentChannel = this.state.channelStoreState.channelsAndOrgs.find(c => c.id === currentChannelId);
        const currentProject = this.state.projectStoreState.project;
        return (
            <div>
                <MainNav
                    onClickBrandLogo={Navigator.goToDashboardAuthorAuthoringChannelView.bind(this, this.props.history, this.props.match.params.channelId)}
                />
                <div className="container-fluid main-container">
                    <SubNav containerClassName="subnav__container-fluid">
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                {Strings['en'].analytics.overview.DET_ACT_ANALYTICS}
                            </div>
                            <div className="view-description">
                                <BreadCrumbs
                                    links={[
                                        {
                                            href: Navigator.paths.dashboard_author_channel_view(this.props.match.params.channelId),
                                            text: currentChannel.name
                                        },
                                        {
                                            href: `/project/${this.props.match.params.channelId}/${this.props.match.params.projectId}`,
                                            text: currentProject.name
                                        }

                                    ]}
                                />
                            </div>
                        </div>
                    </SubNav>

                    <ProjectAnalytics
                        className="padding-all-md"
                        channelId={this.props.match.params.channelId}
                        projectId={this.props.match.params.projectId}
                    />
                </div>
            </div>
        );
    }
}

ProjectAnalyticsView.propTypes = propTypes;
ProjectAnalyticsView.defaultProps = defaultProps;

export default withRouter(ProjectAnalyticsView);